import { useState, useEffect, useContext } from "react";
import { useController, useForm } from "react-hook-form";
import { Label, Form, FormGroup, Row, Col, Input } from "reactstrap";
import Select from "react-select";
import {
  Stepper,
  Step,
  StepLabel,
  stepConnectorClasses,
  StepConnector,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import {
  createConfigServiceCity,
  updateConfigServiceCity,
  getServiceCityDetails,
} from "../../../Services/ServiceCity.service";
import { getAggregators } from "../../../Services/DispatchDashboard.service";
import { getAllCarTypes, showAlert } from "../../../Services/Shared.service";
import CustomizerContext from "../../../_helper/Customizer";

const PAYMENT_MODE_OPTIONS = [
  { label: "Cash", value: "Cash" },
  { label: "CreditCard", value: "CreditCard" },
  { label: "UPI", value: "UPI" },
  { label: "Wallet", value: "Wallet" },
];

export const ServiceCityConfigForm = (props) => {
  const { cityData, editId, toggleModal, trgiggerRefresh, fetchData } = props;

  const [aggregatorList, setAggregatorList] = useState([]);
  const [carTypeList, setCarTypeList] = useState([]);
  const [selectAggregator, setSelectAggregator] = useState();
  const [selectCarType, setSelectCarType] = useState();
  const [selectPaymentModes, setSelectPaymentModes] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [fetchedCityData, setFetchedCityData] = useState(null);

  const STEPS = [
    { id: 1, label: "General Info", fields: ["name", "companyName", "aggregator", "cityCode", "serviceDesc", "website", "kml"] },
    { id: 2, label: "Operations", fields: ["callCentreMobile", "sosHelpline", "airportHelpline", "carType", "paymentModes"] },
    { id: 3, label: "Legal & Tax", fields: ["gstNo", "cinNo", "sacCode", "placeOfSupply", "invoiceLabel", "address", "registeredOfficeAddress", "digitalSignUrl"] },
    { id: 4, label: "Advanced", fields: ["oldCompanyName", "shortDistance", "oldAddress", "oldCinNo", "oldGstNo", "rideNowSec", "rideLaterSec"] },
  ];

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    trigger,
  } = useForm({});

  const { mix_background_layout } = useContext(CustomizerContext);



  const validateGSTNumber = (value) => {
    const regex = /^[a-zA-Z0-9]*$/;
    if (value.length !== 15) {
      return "GST No must be 15 characters";
    }
    if (!regex.test(value)) {
      return "GST No must not contain special characters";
    }
    return true;
  };

  const isWalletEnabledField = useController({
    name: "isWalletEnabled",
    control,
  }).field;

  const resetFormData = () => {
    reset({
      name: "",
      companyName: "",
      aggregator: "",
      placeOfSupply: "",
      invoiceLabel: "",
      address: "",
      digitalSignUrl: "",
      cityCode: "",
      callCentreMobile: "",
      registeredOfficeAddress: "",
      website: "",
      sacCode: "",
      gstNo: "",
      cinNo: "",
      serviceDesc: "",
      carType: "",
      isWalletEnabled: false,
      kml: "",
      paymentModes: "",
      sosHelpline: "",
      airportHelpline: "",
      estimateEnabled: true,
      oldCompanyName: "",
      shortDistance: "",
      oldAddress: "",
      oldCinNo: "",
      oldGstNo: "",
      rideNowSec: "",
      rideLaterSec: "",
    });

    setSelectAggregator();
    setSelectCarType();
    setSelectPaymentModes([]);
    setCurrentStep(1);
  };

  const onFormSubmit = (formValues) => {
    const filteredCarType = formValues.carType ? formValues.carType.map((item) => item.value.id) : [];
    const filteredPaymentModes = formValues.paymentModes ? formValues.paymentModes.map((item) => item.value) : [];

    const requestPayload = {
      name: formValues.name || null,
      companyName: formValues.companyName || null,
      aggregatorId: selectAggregator?.value?.id || null,
      placeOfSupply: formValues.placeOfSupply || null,
      invoiceLabel: formValues.invoiceLabel || null,
      address: formValues.address || null,
      digitalSignatureUrl: formValues.digitalSignUrl || null,
      cityCode: formValues.cityCode || null,
      callCentreMobile: formValues.callCentreMobile || null,
      registeredOfficeAddress: formValues.registeredOfficeAddress || null,
      website: formValues.website || null,
      sacCode: formValues.sacCode || null,
      gstNo: formValues.gstNo || null,
      cinNo: formValues.cinNo || null,
      serviceDescription: formValues.serviceDesc || null,
      carTypes: filteredCarType.length > 0 ? filteredCarType : null,
      walletEnabled: formValues.isWalletEnabled ? true : false,
      paymentModes: filteredPaymentModes.length > 0 ? filteredPaymentModes : [],
      sosHelpline: formValues.sosHelpline || null,
      airportHelpline: formValues.airportHelpline || null,
      estimateEnabled: true,
      
      oldCompanyName: formValues.oldCompanyName || "",
      shortDistance: formValues.shortDistance ? parseFloat(formValues.shortDistance) : null,
      oldAddress: formValues.oldAddress || "",
      oldCinNo: formValues.oldCinNo || "",
      oldGstNo: formValues.oldGstNo || "",
      biddingDurationRideNow: formValues.rideNowSec ? parseInt(formValues.rideNowSec) : null,
      biddingDurationRideLater: formValues.rideLaterSec ? parseInt(formValues.rideLaterSec) : null,
    };
    
    const requestBlob = new Blob([JSON.stringify(requestPayload)], { type: 'application/json' });
    const formData = new FormData();
    formData.append("request", requestBlob);

    if (formValues.kml && formValues.kml.length > 0 && typeof formValues.kml !== "string") {
      formData.append("kmlFile", formValues.kml[0]);
    }

    if (editId != null) {
      updateConfigServiceCity(editId, formData)
        .then((res) => {
          toggleModal();
          trgiggerRefresh();
          if (fetchData) fetchData();
          showAlert("success", "Service city updated successfully");
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
        });
    } else {
      createConfigServiceCity(formData)
        .then((res) => {
          toggleModal();
          trgiggerRefresh();
          if (fetchData) fetchData();
          showAlert("success", "Service city created successfully");
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
        });
    }
  };

  useEffect(() => {
    getAggregators().then((result) => {
      if (result.data) {
        const data = result.data.map((element) => {
          return {
            label: element.companyName,
            value: element,
          };
        });
        setAggregatorList(data);
      }
    });

    getAllCarTypes({ page: 0, size: 30 })
      .then((result) => {
        if (result.data) {
          const data = result.data.content.map((element) => {
            return {
              label: element.name,
              value: element,
            };
          });

          setCarTypeList(data);
        }
      })
      .catch((err) => {
        showAlert(
          "error",
          err.response?.data?.message
            ? err.response.data.message
            : "Unable to fetch Car details for selected City"
        );
      });
  }, []);

  useEffect(() => {
    if (!editId) {
      setFetchedCityData(null);
      resetFormData();
      setSelectAggregator(undefined);
      setSelectCarType(undefined);
      setSelectPaymentModes([]);
      return;
    }

    getServiceCityDetails({ service_city_id: editId })
      .then((res) => {
        if (res?.data) {
          setFetchedCityData(res.data);
        }
      })
      .catch((err) => {
        showAlert("error", err.response?.data?.message || "Failed to fetch city details");
      });
  }, [editId]);

  useEffect(() => {
    if (!fetchedCityData) return;

    const cityDetails = fetchedCityData;

    const selectedAggregatorData = aggregatorList.find(
      (agg) => String(agg?.value?.id) === String(cityDetails?.aggregatorId)
    );
    setSelectAggregator(selectedAggregatorData || { label: cityDetails?.aggregator, value: null });

    const selectedModes = cityDetails?.paymentModes?.map(pm => PAYMENT_MODE_OPTIONS.find(o => o.value === pm)) || [];
    setSelectPaymentModes(selectedModes.filter(Boolean));

    const carTypesData = cityDetails?.carTypes || [];

    const selectedCars = carTypesData.map((car) => {
      const carId = typeof car === "object" ? car?.id : car;
      const matchedCar = carTypeList.find((c) => String(c?.value?.id) === String(carId));
      return matchedCar || { label: car?.name || `Car ${carId}`, value: { id: carId, name: car?.name } };
    });
    setSelectCarType(selectedCars.length > 0 ? selectedCars : undefined);

    reset({
      name: cityDetails?.name || "",
      companyName: cityDetails?.companyName || "",
      aggregator: cityDetails?.aggregator || "",
      placeOfSupply: cityDetails?.placeOfSupply || "",
      invoiceLabel: cityDetails?.invoiceLabel || "",
      address: cityDetails?.address || "",
      digitalSignUrl: cityDetails?.digitalSignatureUrl || "",
      cityCode: cityDetails?.cityCode || "",
      callCentreMobile: cityDetails?.callCentreMobile || "",
      registeredOfficeAddress: cityDetails?.registeredOfficeAddress || "",
      website: cityDetails?.website || "",
      sacCode: cityDetails?.sacCode || "",
      gstNo: cityDetails?.gstNo || "",
      cinNo: cityDetails?.cinNo || "",
      serviceDesc: cityDetails?.serviceDescription || "",
      isWalletEnabled: cityDetails?.isWalletEnabled || false,
      kml: "",
      paymentModes: selectedModes,
      sosHelpline: cityDetails?.sosHelpline || "",
      airportHelpline: cityDetails?.airportHelpline || "",
      estimateEnabled: true,

      oldCompanyName: cityDetails?.oldCompanyName || "",
      shortDistance: cityDetails?.shortDistance || "",
      oldAddress: cityDetails?.oldAddress || "",
      oldCinNo: cityDetails?.oldCinNo || "",
      oldGstNo: cityDetails?.oldGstNo || "",
      rideNowSec: cityDetails?.biddingDurationRideNow || "",
      rideLaterSec: cityDetails?.biddingDurationRideLater || "",
      
      carType: selectedCars,
    });

    if (cityDetails?.kml) {
      try {
        const fileName = `${cityDetails.name || 'Existing_City'}.kml`;
        const file = new File([cityDetails.kml], fileName, { type: 'application/vnd.google-earth.kml+xml' });
        const dt = new DataTransfer();
        dt.items.add(file);
        setValue("kml", dt.files);
        setTimeout(() => {
          const fileInput = document.getElementById("kml-input-city");
          if (fileInput) fileInput.files = dt.files;
        }, 0);
      } catch (e) {
        console.error("Error setting file input", e);
      }
    }
  }, [fetchedCityData, aggregatorList, carTypeList, reset, setValue]);

  // Automatically switch to the earliest step with validation errors
  useEffect(() => {
    const errorKeys = Object.keys(errors);
    if (errorKeys.length > 0) {
      for (const step of STEPS) {
        const hasError = step.fields.some(field => errorKeys.includes(field));
        if (hasError) {
          setCurrentStep(step.id);
          break;
        }
      }
    }
  }, [errors]);

  const handleStepClick = async (stepId) => {
    if (stepId === currentStep) return;
    if (stepId < currentStep) {
      // Going backward is always allowed
      setCurrentStep(stepId);
    } else {
      // Validate all steps between currentStep and stepId sequentially
      let stepToValidate = currentStep;
      while (stepToValidate < stepId) {
        const fieldsToValidate = STEPS[stepToValidate - 1].fields;
        const isValid = await trigger(fieldsToValidate);
        if (!isValid) {
          setCurrentStep(stepToValidate);
          return;
        }
        stepToValidate++;
      }
      setCurrentStep(stepId);
    }
  };

  // MUI Stepper: green connector line
  const GreenConnector = styled(StepConnector)(() => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: { top: 17 },
    [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: { backgroundColor: '#11BF5C' },
    [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: { backgroundColor: '#11BF5C' },
    [`& .${stepConnectorClasses.line}`]: {
      height: 3,
      border: 0,
      backgroundColor: '#eaeaea',
      borderRadius: 1,
    },
  }));

  return (
    <div>
      <div>
        <Form onSubmit={handleSubmit(onFormSubmit)}>
          {/* MUI Stepper */}
          <Stepper
            alternativeLabel
            activeStep={currentStep - 1}
            connector={<GreenConnector />}
            sx={{ mb: 3, pt: 1 }}
          >
            {STEPS.map((step) => (
              <Step
                key={step.id}
                completed={currentStep > step.id}
                onClick={() => handleStepClick(step.id)}
                sx={{ cursor: currentStep > step.id || step.id < currentStep ? 'pointer' : 'default' }}
              >
                <StepLabel
                  StepIconProps={{
                    sx: {
                      color: '#eaeaea',
                      '&.Mui-active': { color: '#11BF5C' },
                      '&.Mui-completed': { color: '#11BF5C' },
                      width: 36,
                      height: 36,
                    },
                  }}
                  sx={{
                    '& .MuiStepLabel-label': {
                      fontSize: '13px',
                      fontWeight: 500,
                      color: '#999',
                      whiteSpace: 'nowrap',
                      mt: '4px !important',
                    },
                    '& .MuiStepLabel-label.Mui-active': { color: '#11BF5C', fontWeight: 600 },
                    '& .MuiStepLabel-label.Mui-completed': { color: '#333', fontWeight: 500 },
                  }}
                >
                  {step.label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>

          {/* Form Content Steps */}
          <div style={{ minHeight: '200px', padding: '10px 0' }}>
            {/* Step 1: General Info */}
            {currentStep === 1 && (
              <div>
                <Row>
                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">Name</Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("name", {
                          required: {
                            value: true,
                            message: "Name is required",
                          },
                          onChange: (e) => {
                            setValue("name", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>{errors?.name?.message}</span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">Company Name</Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("companyName", {
                          required: {
                            value: true,
                            message: "Company Name is required",
                          },
                          onChange: (e) => {
                            setValue("companyName", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.companyName?.message}
                      </span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">Aggregator</Label>
                    <Col lg="12">
                      <Select
                        value={selectAggregator}
                        options={aggregatorList}
                        onChange={(e) => {
                          setValue("aggregator", e);
                          setSelectAggregator(e);
                        }}
                        isSearchable={true}
                        placeholder={"Select Aggregator"}
                        menuPortalTarget={document.body} 
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.aggregator?.message}
                      </span>
                    </Col>
                  </FormGroup>
                </Row>

                <Row className="mt-2">
                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">City Code</Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("cityCode", {
                          required: {
                            value: true,
                            message: "City Code is required",
                          },
                          onChange: (e) => {
                            setValue("cityCode", e.target.value.trimStart());
                          },
                          validate: (value) =>
                            value.length <= 3 ||
                            "City code must be 3 characters or less",
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.cityCode?.message}
                      </span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">
                      Service Description
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("serviceDesc", {
                          required: {
                            value: true,
                            message: "Service Description is required",
                          },
                          onChange: (e) => {
                            setValue("serviceDesc", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.serviceDesc?.message}
                      </span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">Website</Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("website", {
                          required: {
                            value: true,
                            message: "Website is required",
                          },
                          onChange: (e) => {
                            setValue("website", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.website?.message}
                      </span>
                    </Col>
                  </FormGroup>
                </Row>

                <Row className="mt-2">
                  <FormGroup className="col-md-12">
                    <Label className="col-lg-12 col-form-label">KML Boundary File {!editId && <span style={{ color: "red" }}>*</span>}</Label>
                    <Col lg="12">
                      {editId && <div style={{ fontSize: "12px", color: "#666", marginBottom: "5px" }}>Upload a new file to replace the existing KML boundary.</div>}
                      <input
                        id="kml-input-city"
                        type="file"
                        accept=".kml,.xml"
                        className="form-control"
                        {...register("kml", {
                          required: editId ? false : "KML Data file is required",
                        })}
                      />
                      <span style={{ color: "red" }}>{errors?.kml?.message}</span>
                    </Col>
                  </FormGroup>
                </Row>
              </div>
            )}

            {/* Step 2: Operations & Helplines */}
            {currentStep === 2 && (
              <div>
                <Row>
                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">
                      Call Centre Mobile
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control no-arrows"
                        type="number"
                        {...register("callCentreMobile", {
                          required: {
                            value: true,
                            message: "Call Centre Mobile is required",
                          },
                          onChange: (e) => {
                            setValue("callCentreMobile", e.target.value.trimStart());
                          },
                          validate: (value) =>
                            value.length === 10 || "Call centre mobile must be 10 digits",
                        })}
                        onInput={(e) => {
                          if (e.target.value.length > 10) {
                            e.target.value = e.target.value.slice(0, 10);
                          }
                        }}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.callCentreMobile?.message}
                      </span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">SOS Helpline</Label>
                    <Col lg="12">
                      <input
                        className="form-control no-arrows"
                        type="number"
                        {...register("sosHelpline", {
                          required: { value: true, message: "Required" },
                          onChange: (e) => setValue("sosHelpline", e.target.value.trimStart())
                        })}
                      />
                      <span style={{ color: "red" }}>{errors?.sosHelpline?.message}</span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">Airport Helpline</Label>
                    <Col lg="12">
                      <input
                        className="form-control no-arrows"
                        type="number"
                        {...register("airportHelpline", {
                          required: { value: true, message: "Required" },
                          onChange: (e) => setValue("airportHelpline", e.target.value.trimStart())
                        })}
                      />
                      <span style={{ color: "red" }}>{errors?.airportHelpline?.message}</span>
                    </Col>
                  </FormGroup>
                </Row>

                <Row className="mt-2">
                  <FormGroup className="col-md-4">
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center', paddingTop: '1.8rem' }}>
                      <div
                        className={
                          mix_background_layout === "dark-only"
                            ? "checkbox-dark p-0"
                            : "checkbox p-0"
                        }
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Input
                          id="isWalletEnabled"
                          type="checkbox"
                          checked={isWalletEnabledField.value}
                          onChange={(value) => isWalletEnabledField.onChange(value)}
                        />
                        <Label className="mb-0" for="isWalletEnabled" style={{ marginLeft: "5px" }}>
                          Wallet Enabled
                        </Label>
                      </div>
                    </div>
                  </FormGroup>

                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">Car Type</Label>
                    <Col lg="12">
                      <Select
                        isMulti
                        value={selectCarType}
                        options={carTypeList}
                        onChange={(e) => {
                          setValue("carType", e);
                          setSelectCarType(e);
                        }}
                        isSearchable={true}
                        placeholder={"Select Car Type"}
                        menuPortalTarget={document.body} 
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.carType?.message}
                      </span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">Payment Modes</Label>
                    <Col lg="12">
                      <Select
                        isMulti
                        value={selectPaymentModes}
                        options={PAYMENT_MODE_OPTIONS}
                        onChange={(e) => {
                          setValue("paymentModes", e);
                          setSelectPaymentModes(e);
                        }}
                        isSearchable={true}
                        placeholder={"Select Modes"}
                        menuPortalTarget={document.body} 
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.paymentModes?.message}
                      </span>
                    </Col>
                  </FormGroup>
                </Row>
              </div>
            )}

            {/* Step 3: Legal & Tax */}
            {currentStep === 3 && (
              <div>
                <Row>
                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">GST No.</Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        maxLength="15"
                        {...register("gstNo", {
                          required: {
                            value: true,
                            message: "GST No is required",
                          },
                          onChange: (e) => {
                            setValue("gstNo", e.target.value.trimStart());
                          },
                          validate: validateGSTNumber,
                        })}
                      />
                      <span style={{ color: "red" }}>{errors?.gstNo?.message}</span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">CIN No.</Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("cinNo", {
                          required: {
                            value: true,
                            message: "CIN No is required",
                          },
                          onChange: (e) => {
                            setValue("cinNo", e.target.value.trimStart());
                          },
                          validate: (value) =>
                            value.length === 21 || "CIN No must be 21 characters",
                        })}
                      />
                      <span style={{ color: "red" }}>{errors?.cinNo?.message}</span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">SAC Code</Label>
                    <Col lg="12">
                      <input
                        className="form-control no-arrows"
                        type="number"
                        {...register("sacCode", {
                          required: {
                            value: true,
                            message: "SAC Code is required",
                          },
                          onChange: (e) => {
                            setValue("sacCode", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.sacCode?.message}
                      </span>
                    </Col>
                  </FormGroup>
                </Row>

                <Row className="mt-2">
                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">
                      Place of Supply
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("placeOfSupply", {
                          required: {
                            value: true,
                            message: "Place of Supply is required",
                          },
                          onChange: (e) => {
                            setValue("placeOfSupply", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.placeOfSupply?.message}
                      </span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">
                      Invoice Label
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("invoiceLabel", {
                          required: {
                            value: true,
                            message: "Invoice Label is required",
                          },
                          onChange: (e) => {
                            setValue("invoiceLabel", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.invoiceLabel?.message}
                      </span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">
                      Digital Signature URL
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("digitalSignUrl", {
                          required: {
                            value: true,
                            message: "Digital Signature URL is required",
                          },
                          onChange: (e) => {
                            setValue("digitalSignUrl", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.digitalSignUrl?.message}
                      </span>
                    </Col>
                  </FormGroup>
                </Row>

                <Row className="mt-2">
                  <FormGroup className="col-md-6">
                    <Label className="col-lg-12 col-form-label">Address</Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("address", {
                          required: {
                            value: true,
                            message: "Address is required",
                          },
                          onChange: (e) => {
                            setValue("address", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.address?.message}
                      </span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-md-6">
                    <Label className="col-lg-12 col-form-label">
                      Registered Office Address
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("registeredOfficeAddress", {
                          required: {
                            value: true,
                            message: "Registered Office Address is required",
                          },
                          onChange: (e) => {
                            setValue("registeredOfficeAddress", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>
                        {errors?.registeredOfficeAddress?.message}
                      </span>
                    </Col>
                  </FormGroup>
                </Row>
              </div>
            )}

            {/* Step 4: Advanced Settings */}
            {currentStep === 4 && (
              <div>
                <Row>
                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">
                      Old Company Name
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("oldCompanyName", {
                          onChange: (e) => {
                            setValue("oldCompanyName", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>{errors?.oldCompanyName?.message}</span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">
                      Short Distance
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("shortDistance", {
                          onChange: (e) => {
                            setValue("shortDistance", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>{errors?.shortDistance?.message}</span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">
                      Old CIN No.
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("oldCinNo", {
                          onChange: (e) => {
                            setValue("oldCinNo", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>{errors?.oldCinNo?.message}</span>
                    </Col>
                  </FormGroup>
                </Row>

                <Row className="mt-2">
                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">
                      Old GST No.
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("oldGstNo", {
                          onChange: (e) => {
                            setValue("oldGstNo", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>{errors?.oldGstNo?.message}</span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">
                      Bidding duration seconds ride now
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("rideNowSec", {
                          onChange: (e) => {
                            setValue("rideNowSec", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>{errors?.rideNowSec?.message}</span>
                    </Col>
                  </FormGroup>

                  <FormGroup className="col-md-4">
                    <Label className="col-lg-12 col-form-label">
                      Bidding duration seconds ride later
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("rideLaterSec", {
                          onChange: (e) => {
                            setValue("rideLaterSec", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>{errors?.rideLaterSec?.message}</span>
                    </Col>
                  </FormGroup>
                </Row>

                <Row className="mt-2">
                  <FormGroup className="col-md-12">
                    <Label className="col-lg-12 col-form-label">
                      Old Address
                    </Label>
                    <Col lg="12">
                      <input
                        className="form-control"
                        type="text"
                        {...register("oldAddress", {
                          onChange: (e) => {
                            setValue("oldAddress", e.target.value.trimStart());
                          },
                        })}
                      />
                      <span style={{ color: "red" }}>{errors?.oldAddress?.message}</span>
                    </Col>
                  </FormGroup>
                </Row>
              </div>
            )}
          </div>

          <style>
            {`
              /* Chrome, Safari, Edge, Opera */
              .no-arrows::-webkit-outer-spin-button,
              .no-arrows::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
              }
              /* Firefox */
              .no-arrows[type="number"] {
                -moz-appearance: textfield;
              }
            `}
          </style>

          {/* Action Buttons */}
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: '20px',
            borderTop: '1px solid #f0f0f0',
            paddingTop: '15px'
          }}>
            <div>
              {currentStep > 1 && (
                <button
                  key="back-btn"
                  type="button"
                  className="btn btn-light"
                  onClick={() => setCurrentStep(currentStep - 1)}
                  style={{ minWidth: '100px', fontWeight: '600' }}
                >
                  Back
                </button>
              )}
            </div>
            <div>
              {currentStep < 4 ? (
                <button
                  key="next-btn"
                  type="button"
                  className="btn submit-button"
                  onClick={async () => {
                    const fieldsToValidate = STEPS[currentStep - 1].fields;
                    const isValid = await trigger(fieldsToValidate);
                    if (isValid) {
                      setCurrentStep(currentStep + 1);
                    }
                  }}
                  style={{ minWidth: '100px', fontWeight: '600' }}
                >
                  Next
                </button>
              ) : (
                <button
                  key="submit-btn"
                  type="submit"
                  className="btn submit-button"
                  style={{ minWidth: '100px', fontWeight: '600' }}
                >
                  {editId ? "Update" : "Create"}
                </button>
              )}
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ServiceCityConfigForm;
